<template>
  <div class="page_staff">
    <slot><div></div></slot>
    <div class="page_staff_member">
      <label>负责人：</label>
      <span v-for="user in pd" :key="`pd_${user.email}`">
        {{ user.name }} <a @click="loadPopo(user.email)" class="popo"></a>
      </span>
    </div>
  </div>
</template>
<script>
import { encrypt } from "@/utils/utils";
export default {
  props: ["pd", "content"],
  methods: {
    loadPopo(email) {
      const b = {
        opss: {
          sstp: 0,
          ssid: email,
        },
      };
      window.location.href = "netease-popoapp://" + encrypt(JSON.stringify(b));
    },
  },
};
</script>

<style lang="less" scoped>
.page_staff {
  display: flex;
  justify-content: space-between;
  .page_staff_member {
    font-size: 13px;
    font-weight: normal;
    color: rgba(0, 0, 0, 0.6);
    text-align: right;
    width: 100%;
    height: 30px;
    padding: 10px 0 0 0;
    display: flex;
    justify-content: flex-end;
    label {
      margin: 0 0 0 25px;
      vertical-align: middle;
    }
    span {
      margin: 0 10px 0 0;
      a.popo {
        width: 16px;
        height: 16px;
        background: url("../../../../assets/img/popo.png") no-repeat;
        background-size: 16px 16px;
        display: inline-block;
        vertical-align: middle;
        margin: -2px 0 0 0;
      }
    }
  }
}
</style>
